/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { MetadataContainer } from '../container';

interface Relationship<T> {
  repository: any;
  expression?: { [name: string]: (object: T) => any };
  api?: (object: T) => any;
  headers?: HttpHeaders | { [header: string]: string | string[] };
}

export function OneToOne<T>(configuration: Relationship<T>) {
  return function(target: Object, propertyKey: string) {
    let value: any = of(null);

    const getter = function(this: { [name: string]: any }) {
      const queryString = {};
      let newApi = '';
      let hasValue = true;

      // creating query string to do the search
      if (configuration.expression) {
        const propertyNames = Object.keys(configuration.expression);

        propertyNames.forEach((property) => {
          const val = configuration.expression[property](this as T);
          if (!val) {
            hasValue = false;
          }
          queryString[property] = val;
        });
      }

      // overload api
      if (configuration.api) {
        newApi = configuration.api(this as T);

        if (!newApi) {
          hasValue = false;
        }
      }

      if (hasValue) {
        const repository = MetadataContainer.pool.getRepository(
          configuration.repository
        );

        const oldApi = repository.api;
        repository.api = `${repository.api}${newApi}`;
        repository.headers = configuration?.headers ?? {};
        value = repository.getOne(queryString);
        repository.api = oldApi;
      }

      return value;
    };

    const setter = (newVal: any) => {
      value = newVal;
    };

    Object.defineProperty(target, propertyKey, {
      get: getter,
      set: setter,
    });
  };
}
